/* eslint-disable no-multi-str */
export const sessionStorageRootKey = "@Vbz:update-member";
export const sessionToken = "session-token";
